import type { ComputedRef, InjectionKey } from 'vue';

export const isCopyInjectionKey: InjectionKey<ComputedRef<boolean>> = Symbol();
